module.exports = __webpack_public_path__ + "img/ok_large.f76aeada.svg";